import { http, HttpResponse } from 'msw'
import { IssuerDto } from '../components/shared/types'

export const mockIssuers: IssuerDto[] = [
  {
    issuerTenantId: 'tenant-1-id',
    displayName: 'Tenant One',
    enabled: true,
  },
  {
    issuerTenantId: 'tenant-2-id',
    displayName: 'Tenant Two',
    enabled: true,
  },
  {
    issuerTenantId: 'issuer-1-id',
    displayName: 'Issuer One Corp',
    enabled: true,
  },
  {
    issuerTenantId: 'issuer-2-id',
    displayName: 'Issuer Two LLC',
    enabled: true,
  },
]

export const handlers = [
  http.get('**/issuers', () => {
    return HttpResponse.json(mockIssuers)
  }),
]
